// Image type constants for Mitek verification
export const IMAGE_TYPES: Record<string, string> = {
  DL_FRONT: 'DL_FRONT',
  DL_BACK: 'PDF417_BARCODE',
  SELFIE: 'SELFIE',
  PASSPORT: 'PASSPORT'
};

// Image type labels for display
export const IMAGE_TYPE_LABELS: Record<string, string> = {
  [IMAGE_TYPES.DL_FRONT]: 'Front Of ID',
  [IMAGE_TYPES.DL_BACK]: 'Back Of ID',
  [IMAGE_TYPES.SELFIE]: 'Selfie',
  [IMAGE_TYPES.PASSPORT]: 'Passport'
};

